import { useState } from "react";
import { getFaqs } from "./data";
import styles from "./pricing.module.css";

export default function FAQSection({ isNGN }) {
  const [open, setOpen] = useState(null);
  const FAQS = getFaqs(isNGN);

  return (
    <div className={styles.faqSection}>
      <div className={styles.faqHeader}>
        <div className={styles.faqHeaderTitle}>Frequently asked questions</div>
        <div className={styles.faqHeaderSub}>
          Everything about credits, validity, and billing
        </div>
      </div>
      <div className={styles.faqList}>
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ""}`}
            >
              <button
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className={styles.faqQuestion}
              >
                <span className={styles.faqQuestionText}>{f.q}</span>
                <span
                  className={`${styles.faqIcon} ${isOpen ? styles.faqIconOpen : ""}`}
                >
                  +
                </span>
              </button>
              {isOpen && <div className={styles.faqAnswer}>{f.a}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
